import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

const groupDefinitions = [
  {
    name: "Spices & herbs",
    href: "/collections/spices-seasonings-herbs",
    imageSlug: "ground-spices",
    categorySlugs: ["ground-spices", "whole-spices", "herbs", "blends"],
    links: [
      ["Ground spices", "/collections/ground-spices"],
      ["Whole spices", "/collections/whole-spices"],
      ["Herbs", "/collections/herbs"],
      ["Seasoning blends", "/collections/blends"],
    ],
  },
  {
    name: "Baking pantry",
    href: "/collections/baking",
    imageSlug: "baking",
    categorySlugs: ["baking"],
    links: [
      ["Baking spices", "/collections/baking"],
      ["Ceylon cinnamon", "/products/ceylon-cinnamon"],
      ["Vanilla beans", "/products/madagascar-vanilla-beans"],
      ["Dutch cocoa", "/products/dutch-cocoa"],
    ],
  },
  {
    name: "Salt & specialties",
    href: "/shop?collection=salt-specialties",
    imageSlug: "salts",
    categorySlugs: ["salts", "rare-ingredients"],
    links: [
      ["Finishing salts", "/collections/salts"],
      ["Rare ingredients", "/collections/rare-ingredients"],
      ["Health & wellness", "/shop?tag=wellness"],
      ["Best sellers", "/shop?collection=best-sellers"],
    ],
  },
];

const CategoryCards = ({ categories }) => {
  const bySlug = new Map(categories.map((category) => [category.slug, category]));

  return (
    <section className="section category-section">
      <div className="site-container">
        <header className="section-heading section-heading--center">
          <p className="eyebrow">Find your flavor</p>
          <h2>Shop spices by category</h2>
          <p>From everyday workhorses to ingredients worth planning dinner around.</p>
        </header>
        <div className="category-cards">
          {groupDefinitions.map((group) => {
            const image = bySlug.get(group.imageSlug)?.image;
            const count = group.categorySlugs.reduce((total, slug) => total + (bySlug.get(slug)?.count || 0), 0);
            return (
              <article className="category-card" key={group.name}>
                <Link className="category-card__image" to={group.href}>
                  <img src={image} alt={`${group.name} assortment`} loading="lazy" />
                </Link>
                <div className="category-card__body">
                  <div className="category-card__heading">
                    <Link to={group.href}><strong>{group.name}</strong></Link>
                    <small>{count} products</small>
                  </div>
                  <ul>{group.links.map(([label, href]) => <li key={label}><Link to={href}>{label}<FiArrowRight aria-hidden="true" /></Link></li>)}</ul>
                  <Link className="category-card__more" to={group.href}>Explore all <FiArrowRight aria-hidden="true" /></Link>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategoryCards;
